import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-noauthroized',
    templateUrl: './noauthroized.component.html',
    styleUrls: ['./noauthroized.component.css'],
    standalone: false
})
export class NoauthroizedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
